"use strict";

var _interopRequireDefault = require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

var _typeof = require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/typeof.js");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.weak-map");

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/es6.object.keys");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.regexp.split");

require("core-js/modules/web.dom.iterable");

var _defineProperty2 = _interopRequireDefault(require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/defineProperty.js"));

var _stat = _interopRequireWildcard(require("@/api/stat"));

var _statItem = _interopRequireDefault(require("@/api/statItem"));

var _crud = _interopRequireWildcard(require("@crud/crud"));

var _RR = _interopRequireDefault(require("@crud/RR.operation"));

var _CRUD = _interopRequireDefault(require("@crud/CRUD.operation"));

var _UD = _interopRequireDefault(require("@crud/UD.operation"));

var _Pagination = _interopRequireDefault(require("@crud/Pagination"));

var _methods;

function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) { "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); } return f; })(e, t); }

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }

function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

var defaultForm = {
  statId: null,
  title: null,
  sort: null,
  pid: null,
  userId: null,
  deptId: null,
  createTime: null,
  updateTime: null,
  queryItemType: null,
  itemProp: null,
  itemFunc: null
};
var _default = {
  name: 'Stat',
  components: {
    pagination: _Pagination.default,
    crudOperation: _CRUD.default,
    rrOperation: _RR.default,
    udOperation: _UD.default
  },
  mixins: [(0, _crud.presenter)(), (0, _crud.header)(), (0, _crud.form)(defaultForm), (0, _crud.crud)()],
  cruds: function cruds() {
    return (0, _crud.default)({
      title: '统计报表',
      url: 'api/stat',
      idField: 'statId',
      sort: 'statId,desc',
      crudMethod: _objectSpread({}, _stat.default)
    });
  },
  data: function data() {
    return {
      permission: {
        add: ['admin', 'stat:add'],
        edit: ['admin', 'stat:edit'],
        del: ['admin', 'stat:del']
      },
      formulaFuncs: ['(', ')', '+', '-', '*', '/'],
      formulaNums: ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'],
      all_statuss: [],
      item_cities: [{
        prop: 'qType',
        label: '用户岗位',
        width: 150
      }, {
        prop: 'id',
        query: 'custIds',
        label: '客户编号',
        width: 150
      }, {
        prop: 'name',
        label: '客户姓名',
        width: 150
      }, {
        prop: 'mobile',
        label: '手机号码',
        width: 150
      }, {
        prop: 'createTime',
        label: '创建时间',
        type: 'date',
        width: 150
      }, {
        prop: 'updateTime',
        label: '最后更新时间',
        type: 'date',
        width: 150
      }, {
        prop: 'msgFrom',
        dict: 'cust_msg_from',
        type: 'select',
        label: '客户来源-O2O',
        width: 150
      }, {
        prop: 'businessFrom',
        dict: 'business_from',
        type: 'select',
        label: '客户来源-市场',
        width: 150
      }, {
        prop: 'zxFrom',
        dict: 'zx_from',
        type: 'select',
        label: '客户来源-导购',
        width: 150
      }, {
        prop: 'address',
        label: '地址',
        width: 200
      }, {
        prop: 'province',
        label: '省',
        width: 150
      }, {
        prop: 'city',
        label: '市',
        width: 150
      }, {
        prop: 'district',
        label: '区',
        width: 150
      }, {
        prop: 'followWechat',
        label: '跟进微信',
        width: 150
      }, {
        prop: 'custWechat',
        label: '客户微信',
        width: 150
      }, {
        prop: 'taobaoName',
        label: '旺旺ID',
        width: 150
      }, {
        prop: 'styleFocus',
        label: '客户关注点',
        type: 'select',
        dict: 'cust_style_focus',
        width: 150
      }, {
        prop: 'needProduct1',
        label: '需求产品-定制',
        type: 'select',
        dict: 'need_product1',
        width: 150
      }, {
        prop: 'needProduct2',
        label: '需求产品-家具',
        type: 'select',
        dict: 'need_product2',
        width: 150
      }, {
        prop: 'needProduct3',
        label: '需求产品-门窗',
        type: 'select',
        dict: 'need_product3',
        width: 150
      }, {
        prop: 'budget',
        label: '客户预算',
        type: 'select',
        dict: 'cust_budget',
        width: 150
      }, {
        prop: 'material',
        label: '材料',
        type: 'select',
        dict: 'cust_material',
        width: 150
      }, {
        prop: 'inviter',
        label: '推荐人',
        width: 150
      }, {
        prop: 'remark',
        label: '备注',
        width: 350
      }, {
        prop: 'promoterName',
        userType: '推广',
        label: '提交人员',
        query: 'qNickName',
        width: 150
      }, {
        prop: 'finalApplyTime',
        label: '最后提交时间',
        type: 'date',
        width: 150
      }, {
        prop: 'followStatus1',
        label: '当前-跟进状态',
        width: 150
      }, {
        prop: 'updateStatus1',
        label: '历史-跟进状态',
        type: 'followStatus',
        width: 150
      }, {
        prop: 'kfName',
        userType: '客服',
        label: '跟进客服',
        query: 'qNickName',
        width: 150 // },{
        //   prop: 'kfDept.name',
        //   prop1: 'kfDept',
        //   prop2: 'name',
        //   label: '客服部门'
        // },
        // {
        //   prop: 'zxDept.name',
        //   prop1: 'zxDept',
        //   prop2: 'name',
        //   label: '门店名称'

      }, {
        prop: 'followInfo.hopeIntoStoreTime',
        prop1: 'followInfo',
        prop2: 'hopeIntoStoreTime',
        type: 'date',
        label: '客服-希望进店时间',
        width: 180
      }, {
        prop: 'followInfo.hopeMeasureTime',
        prop1: 'followInfo',
        prop2: 'hopeMeasureTime',
        type: 'date',
        label: '客服-希望量尺时间',
        width: 180
      }, {
        prop: 'followInfo.housePrice',
        prop1: 'followInfo',
        prop2: 'housePrice',
        type: 'select',
        dict: 'house_price',
        label: '客服-房屋单价',
        width: 180
      }, {
        prop: 'followInfo.houseArea',
        prop1: 'followInfo',
        prop2: 'houseArea',
        type: 'select',
        dict: 'house_area',
        label: '客服-房屋面积',
        width: 180
      }, {
        prop: 'followInfo.custArea',
        prop1: 'followInfo',
        prop2: 'custArea',
        type: 'select',
        dict: 'cust_area',
        label: '客服-区域',
        width: 180
      }, {
        prop: 'followInfo.allRoomType',
        prop1: 'followInfo',
        prop2: 'allRoomType',
        type: 'select',
        dict: 'all_room_type',
        label: '客服-全屋非全屋',
        width: 180
      }, {
        prop: 'followInfo.custWish',
        prop1: 'followInfo',
        prop2: 'custWish',
        type: 'select',
        dict: 'cust_wish',
        label: '客服-客户意愿度',
        width: 180
      }, {
        prop: 'followInfo.kfQuote',
        prop1: 'followInfo',
        prop2: 'kfQuote',
        type: 'select',
        dict: 'kf_quote',
        label: '客服-客服报价',
        width: 180
      }, {
        prop: 'followInfo.likeStyle',
        prop1: 'followInfo',
        prop2: 'likeStyle',
        type: 'select',
        dict: 'like_style',
        label: '客服-喜欢风格',
        width: 180
      }, {
        prop: 'followInfo.occupancyTimeLimit',
        prop1: 'followInfo',
        prop2: 'occupancyTimeLimit',
        type: 'select',
        dict: 'occupancy_time_limit',
        label: '客服-入住时间',
        width: 180
      }, {
        prop: 'followInfo.productDemand',
        prop1: 'followInfo',
        prop2: 'productDemand',
        type: 'select',
        dict: 'cust_need_product',
        label: '客服-需求产品',
        width: 180
      }, {
        prop: 'followInfo.kfAcceptFeel',
        prop1: 'followInfo',
        prop2: 'kfAcceptFeel',
        type: 'select',
        dict: 'kf_accept_feel',
        label: '客服-整体感觉(是否接受)',
        width: 200
      }, {
        prop: 'followInfo.kfFocusesFeel',
        prop1: 'followInfo',
        prop2: 'kfFocusesFeel',
        type: 'select',
        dict: 'kf_focuses_feel',
        label: '客服-整体感觉(注重)',
        width: 200
      }, {
        prop: 'followInfo.readiness',
        prop1: 'followInfo',
        prop2: 'readiness',
        type: 'select',
        dict: 'cust_readiness',
        label: '客服-客户方言',
        width: 180
      }, {
        prop: 'followInfo.custLevel',
        prop1: 'followInfo',
        prop2: 'custLevel',
        type: 'select',
        dict: 'cust_level',
        label: '客服-客户等级',
        width: 180
      }, {
        prop: 'followInfo.decorateState',
        prop1: 'followInfo',
        prop2: 'decorateState',
        type: 'select',
        dict: 'decorate_state',
        label: '客服-装修状态',
        width: 180
      }, {
        prop: 'followInfo.decorateType',
        prop1: 'followInfo',
        prop2: 'decorateType',
        type: 'select',
        dict: 'decorate_type',
        label: '客服-装修类型',
        width: 180
      }, {
        prop: 'followInfo.isInCity',
        prop1: 'followInfo',
        prop2: 'isInCity',
        type: 'select',
        dict: 'is_in_city',
        label: '客服-是否市区',
        width: 180
      }, {
        prop: 'followInfo.tab',
        prop1: 'followInfo',
        prop2: 'tab',
        label: '客服-客户标签',
        width: 180
      }, {
        prop: 'storeName',
        userType: '门店导购',
        type: 'no_search',
        label: '门店名称',
        query: 'qDeptName',
        width: 150
      }, {
        prop: 'zxManage',
        userType: '门店店长',
        label: '门店店长',
        query: 'qNickName',
        width: 150
      }, {
        prop: 'zxName',
        userType: '门店导购',
        label: '门店导购',
        query: 'qNickName',
        width: 150
      }, {
        prop: 'storeInto.planIntoTime',
        prop1: 'storeInto',
        prop2: 'planIntoTime',
        type: 'date',
        label: '计划进店时间',
        width: 150
      }, {
        prop: 'storeInto.finalIntoTime',
        prop1: 'storeInto',
        prop2: 'finalIntoTime',
        type: 'date',
        label: '实际进店时间',
        width: 150
      }, {
        prop: 'storeInto.planFollowTime',
        prop1: 'storeInto',
        prop2: 'planFollowTime',
        label: '导购计划跟进时间',
        type: 'date',
        width: 180
      }, {
        prop: 'storeInto.custAge',
        prop1: 'storeInto',
        prop2: 'custAge',
        label: '门店-客户年龄',
        type: 'select',
        dict: 'storeinfo_cust_age',
        width: 150
      }, {
        prop: 'storeInto.custFamily',
        prop1: 'storeInto',
        prop2: 'custFamily',
        label: '门店-常住人员',
        type: 'select',
        dict: 'storeinfo_cust_family',
        width: 150
      }, {
        prop: 'storeInto.houseStage',
        prop1: 'storeInto',
        prop2: 'houseStage',
        label: '门店-装修阶段',
        type: 'select',
        dict: 'storeinfo_house_stage',
        width: 150
      }, {
        prop: 'storeInto.orderValued',
        prop1: 'storeInto',
        prop2: 'orderValued',
        label: '门店-单值',
        type: 'select',
        dict: 'storeinfo_order_valued',
        width: 150
      }, {
        prop: 'storeInto.orderType',
        prop1: 'storeInto',
        prop2: 'orderType',
        label: '门店-订单类型',
        type: 'select',
        dict: 'storeinfo_order_type',
        width: 150
      }, {
        prop: 'storeInto.needProduct',
        prop1: 'storeInto',
        prop2: 'needProduct',
        label: '门店-需要产品',
        type: 'select',
        dict: 'storeinfo_need_product',
        width: 200
      }, {
        prop: 'storeInto.houseStyle',
        prop1: 'storeInto',
        prop2: 'houseStyle',
        label: '门店-装修风格',
        type: 'select',
        dict: 'storeinfo_house_style',
        width: 180
      }, {
        prop: 'storeInto.storeIntoMaterial',
        query: 'storeIntoMaterial',
        prop1: 'storeInto',
        prop2: 'material',
        label: '门店-材料',
        type: 'select',
        dict: 'storeinfo_material',
        width: 180
      }, {
        prop: 'storeInto.firstBudget',
        prop1: 'storeInto',
        prop2: 'firstBudget',
        label: '门店-初步预算',
        width: 180
      }, {
        prop: 'storeInto.cpa',
        prop1: 'storeInto',
        prop2: 'cpa',
        label: '门店-对比竞品情况',
        width: 180
      }, {
        prop: 'storeInto.roomArea',
        prop1: 'storeInto',
        prop2: 'roomArea',
        label: '门店-房屋面积',
        width: 180
      }, {
        prop: 'storeInto.repairCompany',
        prop1: 'storeInto',
        prop2: 'repairCompany',
        label: '门店-装修公司',
        width: 180
      }, {
        prop: 'storeInto.isMeasureSure',
        prop1: 'storeInto',
        prop2: 'isMeasureSure',
        label: '门店-是否测未定',
        width: 180
      }, {
        prop: 'storeInto.planMeasureTime',
        prop1: 'storeInto',
        prop2: 'planMeasureTime',
        type: 'date',
        label: '门店-客户计划测量时间',
        width: 200
      }, {
        prop: 'designLinkUserNickName',
        userType: '设计对接人',
        label: '设计对接人',
        query: 'qNickName',
        width: 180
      }, {
        prop: 'contract',
        prop2: 'contractNo',
        contractType: '合同',
        label: '合同编号',
        query: 'contractNo',
        width: 180
      }, {
        prop: 'contractType',
        prop2: 'type',
        type: 'select',
        dict: 'contract_type',
        contractType: '合同',
        label: '合同类型',
        query: 'contractType',
        width: 180
      }, {
        prop: 'contractTime',
        prop2: 'contractTime',
        contractType: '合同',
        type: 'date',
        label: '签单时间',
        query: 'contractTime',
        width: 180
      }, {
        prop: 'amountReceived',
        prop2: 'amountReceived',
        contractType: '合同',
        label: '已收金额',
        query: 'amountReceived',
        width: 180
      }, {
        prop: 'contractAmount',
        prop2: 'amount',
        contractType: '合同',
        label: '合同金额',
        query: 'contractAmount',
        width: 180
      }, {
        prop: 'measureInto.otherMeasureRemark',
        prop1: 'measureInto',
        prop2: 'otherMeasureRemark',
        label: '量尺-客户其他测量要求',
        width: 200
      }, {
        prop: 'designAllotUserNickName',
        userType: '设计中心派单员',
        label: '设计中心派单员',
        query: 'qNickName',
        width: 150
      }, {
        prop: 'designManageNickName',
        userType: '设计主管',
        label: '设计主管',
        query: 'qNickName',
        width: 150
      }, {
        prop: 'designUserNickName',
        userType: '设计师',
        label: '设计师',
        query: 'qNickName',
        width: 150
      }, {
        prop: 'designDeptName',
        userType: '设计师',
        type: 'no_search',
        label: '设计师部门',
        query: 'qDeptName',
        width: 150
      }, {
        prop: 'measureInto.planMeasureTime',
        prop1: 'storeInto',
        prop2: 'planMeasureTime',
        type: 'date',
        label: '量尺-客户计划测量时间',
        width: 200
      }, {
        prop: 'measureInto.actualMeasureTime',
        prop1: 'measureInto',
        prop2: 'actualMeasureTime',
        type: 'date',
        label: '量尺-实际测量时间',
        width: 180
      }, {
        prop: 'measureInto.finalCheckMeasureTime',
        prop1: 'measureInto',
        prop2: 'finalCheckMeasureTime',
        type: 'date',
        label: '量尺-最后复尺时间',
        width: 180
      }, {
        prop: 'xgtManageUserNickName',
        userType: '效果图组主管',
        label: '效果图组主管',
        query: 'qNickName',
        width: 150
      }, {
        prop: 'xgtUserNickName',
        userType: '效果图组对接人',
        label: '效果图组对接人',
        query: 'qNickName',
        width: 150
      }, {
        prop: 'designInto.designPlanFollowTime',
        prop1: 'designInto',
        prop2: 'designPlanFollowTime',
        type: 'date',
        label: '设计-设计师计划跟进时间',
        width: 200
      }, {
        prop: 'designInto.designSureTime',
        prop1: 'designInto',
        prop2: 'designSureTime',
        type: 'date',
        label: '设计-确认方案时间',
        width: 180
      }, {
        prop: 'designInto.finalDesignSureTime',
        prop1: 'designInto',
        prop2: 'finalDesignSureTime',
        type: 'date',
        label: '设计-最终方案确认时间',
        width: 200
      }, {
        prop: 'sjSdyNickNames',
        userType: '设计审单员',
        label: '设计审单员',
        query: 'qNickName',
        width: 150
      }, {
        prop: 'produceInfo.produceFinishTime',
        prop1: 'produceInfo',
        prop2: 'produceFinishTime',
        type: 'date',
        label: '生产-生产完成时间',
        width: 180
      }, {
        prop: 'produceInfo.produceApprovalStatus',
        prop1: 'produceInfo',
        prop2: 'produceApprovalStatus',
        label: '生产-订单审批状态',
        type: 'select',
        dict: 'produce_approval_status',
        width: 180
      }, {
        prop: 'psNickName',
        userType: '配送',
        label: '配送人员',
        query: 'qNickName',
        width: 150
      }, {
        prop: 'produceInfo.deliveryStatus',
        prop1: 'produceInfo',
        prop2: 'deliveryStatus',
        label: '生产-物流状态',
        type: 'select',
        dict: 'delivery_status',
        width: 180
      }, {
        prop: 'produceInfo.deliveryTime',
        prop1: 'produceInfo',
        prop2: 'deliveryTime',
        type: 'date',
        label: '生产-预约送货时间',
        width: 180
      }, {
        prop: 'produceInfo.installTime',
        prop1: 'produceInfo',
        prop2: 'installTime',
        type: 'date',
        label: '生产-预约安装时间',
        width: 180
      }, {
        prop: 'produceInfo.deliveryFinishTime',
        prop1: 'produceInfo',
        prop2: 'deliveryFinishTime',
        type: 'date',
        label: '生产-送货完成时间',
        width: 180
      }, {
        prop: 'installUserNickName',
        userType: '安装',
        label: '安装人员',
        query: 'qNickName',
        width: 150
      }, {
        prop: 'afterSale.installApprovalStatus',
        prop1: 'afterSale',
        prop2: 'installApprovalStatus',
        label: '安装-安装审批状态',
        type: 'select',
        dict: 'install_approval_status',
        width: 180
      }, {
        prop: 'afterSale.installFinishTime',
        prop1: 'afterSale',
        prop2: 'installFinishTime',
        type: 'date',
        label: '安装-安装完成时间',
        width: 180
      }, {
        prop: 'afterSale.afterSaleStatus',
        prop1: 'afterSale',
        prop2: 'afterSaleStatus',
        label: '安装-售后状态',
        type: 'select',
        dict: 'after_sale_status',
        width: 180
      }, {
        prop: 'afterSale.finishTime',
        prop1: 'afterSale',
        prop2: 'finishTime',
        type: 'date',
        label: '安装-售后完成时间',
        width: 180
      }, {
        prop: 'afterSale.remark',
        query: 'afterSaleRemark',
        prop1: 'afterSale',
        prop2: 'remark',
        label: '安装-售后问题判责',
        width: 180
      }, {
        prop: 'afterSale.isOnFile',
        prop1: 'afterSale',
        prop2: 'isOnFile',
        type: 'select',
        dict: 'yes_or_no',
        label: '安装-是否归档',
        width: 180
      }, {
        prop: 'afterSale.notFileRemark',
        prop1: 'afterSale',
        prop2: 'notFileRemark',
        type: 'select',
        dict: 'not_file_remark',
        label: '安装-未归档原因',
        width: 180
      }],
      //对象数组全部的数据
      dateItems: [{
        value: '<>',
        tag: '=',
        label: '等于两数之间'
      }, {
        value: 'O',
        tag: 'O',
        label: '为空'
      }, {
        value: '∅',
        tag: '∅',
        label: '不为空'
      }],
      items: [{
        value: '=',
        tag: '=',
        label: '等于'
      }, {
        //   value: '!=',
        //   tag: '!=',
        //   label: '不等于'
        // }, {
        value: '⊆',
        tag: '⊆',
        label: '包含(文字)' // }, {
        //   value: '⊈',
        //   tag: '⊈',
        //   label: '不包含(文字)'
        // }, {
        //   value: 'n',
        //   tag: 'n',
        //   label: '等于任意一个'
        // }, {
        //   value: '!n',
        //   tag: '!n',
        //   label: '不等于任意一个'

      }, {
        value: 'O',
        tag: 'O',
        label: '为空'
      }, {
        value: '∅',
        tag: '∅',
        label: '不为空'
      }],
      types: [{
        label: '按部门',
        value: '按部门'
      }, {
        label: '按渠道',
        value: '按渠道'
      }, {
        label: '按人员',
        value: '按人员'
      }],
      query: {},
      queryType: {},
      domain: '',
      selectDepts: [],
      dynamicValidateForm: {
        domains: [],
        isShow: false
      },
      tempSelectionKeys: [],
      rules: {},
      sourceCites: [],
      cities: [],
      listItems: [],
      rightItem: [],
      queryTypeOptions: [{
        key: 'statId',
        display_name: '编号'
      }, {
        key: 'userId',
        display_name: '创建人'
      }, {
        key: 'deptId',
        display_name: '部门'
      }]
    };
  },
  methods: (_methods = {}, (0, _defineProperty2.default)(_methods, _crud.default.HOOK.beforeToAdd, function () {
    var that = this;
    that.cities = that.sourceCites;
    this.query = {};
    this.queryType = {};
    this.dynamicValidateForm = {
      domains: [],
      isShow: false
    };
    this.rightItem = [];
    return true;
  }), (0, _defineProperty2.default)(_methods, _crud.default.HOOK.beforeRefresh, function () {
    var that = this;
    that.cities = [];

    _statItem.default.get({}).then(function (res) {
      var items = res.content;
      items.forEach(function (item) {
        that.cities.push({
          label: item.itemLabel,
          prop: item.itemLabel
        });
      });
      that.sourceCites = that.cities;
    });

    return true;
  }), (0, _defineProperty2.default)(_methods, _crud.default.HOOK.beforeToEdit, function (row) {
    console.log(row);
    this.dynamicValidateForm.isShow = true;
    this.dynamicValidateForm.domains = [];
    this.query = {};
    this.queryType = {}; // this.addDomain()

    console.log(row.form.itemProp);
    var itemProp = row.form.itemProp ? JSON.parse(row.form.itemProp) : [];
    var itemFunc = row.form.itemFunc ? JSON.parse(row.form.itemFunc) : [];

    for (var key in itemFunc) {
      var isMulti = key === 'followStatus1' || key === 'updateStatus1';
      var value = isMulti ? itemProp[key].split(",") : itemProp[key];
      this.dynamicValidateForm.domains.push({
        prop: key,
        func: itemFunc[key],
        value: value
      });
      this.query[key] = value;
    }

    console.log(this.dynamicValidateForm.domains);

    for (var _key in itemFunc) {
      this.queryType[_key] = itemFunc[_key];
    } // this.query = this.form.itemProp
    // this.queryType =this.form.itemFunc


    return true;
  }), (0, _defineProperty2.default)(_methods, _crud.default.HOOK.afterToEdit, function () {
    var that = this;
    that.cities = that.sourceCites;
    this.rightItem = this.form.tabItems.split(","); // this.dynamicValidateForm.domains = []
    // this.dynamicValidateForm.domains.push({
    // })

    return true;
  }), (0, _defineProperty2.default)(_methods, _crud.default.HOOK.beforeSubmit, function () {
    var _this = this;

    console.log(this.dynamicValidateForm);
    this.form.tabItems = this.rightItem.toString();
    console.log(this.dynamicValidateForm.domains);
    var domains = this.dynamicValidateForm.domains;
    domains.forEach(function (domain) {
      _this.query[domain.prop] = domain.value ? domain.value.toString() : "";
      _this.queryType[domain.prop] = domain.func;
    });
    this.form.itemProp = this.query;
    this.form.itemFunc = this.queryType;
    return true;
  }), (0, _defineProperty2.default)(_methods, "handleTabelItemChange", function handleTabelItemChange(value, direction, movedKeys) {
    var _this2 = this;

    // console.log(value, direction, movedKeys);
    this.listItems = [];
    var newRightItem = [];
    value.forEach(function (item) {
      var rItem = _this2.cities.filter(function (x) {
        return x.prop === item;
      });

      _this2.listItems.push(rItem[0]);

      newRightItem.push(rItem[0].prop);
    });
    console.log(newRightItem); // this.rightItem = newRightItem;

    console.log(this.rightItem); // this.rightItem.reverse()
    // console.log(this.listItems);
  }), (0, _defineProperty2.default)(_methods, "rightCheck", function rightCheck(selectionKeys, changeKeys) {
    console.log(selectionKeys);
    console.log(changeKeys);
    this.tempSelectionKeys = selectionKeys;

    if (selectionKeys.length > 0) {
      this.upDownDisable = false;
    } else {
      this.upDownDisable = true;
    }
  }), (0, _defineProperty2.default)(_methods, "upData", function upData() {
    if (this.tempSelectionKeys.length > 1) {
      this.$message({
        type: 'warning',
        message: '仅支持单选调顺序'
      });
      return;
    }

    var indexNum = 0;

    for (var i = 0; i < this.tempSelectionKeys.length; i++) {
      indexNum = this.rightItem.indexOf(this.tempSelectionKeys[i]);

      if (indexNum > 0) {
        this.rightItem.splice(indexNum - 1, 0, this.tempSelectionKeys[i]);
        this.rightItem.splice(indexNum + 1, 1);
        this.listItems = this.rightItem;
      }
    }
  }), (0, _defineProperty2.default)(_methods, "downData", function downData() {
    if (this.tempSelectionKeys.length > 1) {
      this.$message({
        type: 'warning',
        message: '仅支持单选调顺序'
      });
      return;
    }

    var indexNum = 0;

    for (var i = 0; i < this.tempSelectionKeys.length; i++) {
      indexNum = this.rightItem.indexOf(this.tempSelectionKeys[i]);

      if (indexNum > -1 && indexNum != this.rightItem.length - 1) {
        this.rightItem.splice(indexNum + 2, 0, this.tempSelectionKeys[i]);
        this.rightItem.splice(indexNum, 1);
        this.listItems = this.rightItem;
      }
    }
  }), (0, _defineProperty2.default)(_methods, "removeDomain", function removeDomain(item) {
    console.log(item);
    this.query[item.prop] = undefined;
    this.queryType[item.prop] = undefined;
    var index = this.dynamicValidateForm.domains.indexOf(item);

    if (index !== -1) {
      this.dynamicValidateForm.domains.splice(index, 1);
    }
  }), (0, _defineProperty2.default)(_methods, "addDomain", function addDomain() {
    this.dynamicValidateForm.isShow = true;
    this.dynamicValidateForm.domains.push({
      key: Date.now()
    });
  }), _methods)
};
exports.default = _default;